var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectedBluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7596 5.42533L6.0013 0.666992H5.16797V6.99199L1.34297 3.16699L0.167969 4.34199L4.8263 9.00033L0.167969 13.6587L1.34297 14.8337L5.16797 11.0087V17.3337H6.0013L10.7596 12.5753L7.1763 9.00033L10.7596 5.42533ZM6.83464 3.85866L8.4013 5.42533L6.83464 6.99199V3.85866ZM8.4013 12.5753L6.83464 14.142V11.0087L8.4013 12.5753Z",
    fill: "#7BD2EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedBluetooth);
export default __webpack_public_path__ + "static/media/connectedBluetooth.fa7c00614c70e3fee50edbe661c6b684.svg";
export { ForwardRef as ReactComponent };